import { SpreadsheetDashboardType } from '../enums/spreadsheet-dashboard-type.enum';

export class SpreadsheetDashboardTypeHelper {
  public static translateEnum(enumValue: SpreadsheetDashboardType): string | undefined {
    if (enumValue === SpreadsheetDashboardType.InvoicesByYear) {
      return 'Comparatif annuel (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByCustomerAmount) {
      return 'Statistiques clients (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByCustomerPercentage) {
      return 'Statistiques clients (%)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByItemAmount) {
      return 'Statistiques articles (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByItemPercentage) {
      return 'Statistiques articles (%)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByItemQuantity) {
      return 'Statistiques articles (quantités)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByFamilyAmount) {
      return 'Statistiques familles (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByFamilyPercentage) {
      return 'Statistiques familles (%)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByFamilyQuantity) {
      return 'Statistiques familles (quantités)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByCustomerDiscountAmount) {
      return 'Remises sur facture par client (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByCustomerDeliveryFormDiscountAmount) {
      return 'Remises sur bon par client (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByFamilyDeliveryFormDiscountAmount) {
      return 'Remises sur bon par famille (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByFamilyDeliveryFormDiscountQuantity) {
      return 'Remises sur bon par famille (quantités)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByItemDeliveryFormDiscountAmount) {
      return 'Remises sur bon par article (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.InvoicesByItemDeliveryFormDiscountQuantity) {
      return 'Remises sur bon par article (quantités)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityByLaboratoryResourceAmountByMonth) {
      return 'Statistiques ressources (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityByLaboratoryResourceAmountByYear) {
      return 'Statistiques ressources (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityByLaboratoryResourceDurationByMonth) {
      return 'Statistiques ressources (temps)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityByLaboratoryResourceDurationByYear) {
      return 'Statistiques ressources (temps)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityBySectorAmountByMonth) {
      return 'Statistiques secteurs (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityBySectorAmountByYear) {
      return 'Statistiques secteurs (€ HT)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityBySectorDurationByMonth) {
      return 'Statistiques secteurs (temps)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityBySectorDurationByYear) {
      return 'Statistiques secteurs (temps)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityByItemQuantityByLaboratoryResource) {
      return 'Synthèse ressources - articles (quantités)';
    } else if (enumValue === SpreadsheetDashboardType.ActivityByItemAmountByLaboratoryResource) {
      return 'Synthèse ressources - articles (€ HT)';
    } else {
      return undefined;
    }
  }
}
